import { Interval } from 'luxon';

import { UpdateCutoffUnitEnum } from 'application-types';

export type ReservationWithHeadcount = {
  interval: Interval;
  eventType: string | null;
  headcount: number;
};

export type IntervalHeadcountCount = {
  interval: Interval;
  count: number;
  eventType: string | null;
};

export enum ReservableAvailabilityReason {
  Full = 'Full',
  UserCapReached = 'UserCapReached',
}

export type AvailabilityInterval = {
  startDate: Date;
  endDate: Date;
  eventType: string | null;
  remainingSpots: number;
  reason: ReservableAvailabilityReason | null;
};

export enum UpdateActionBlockedReason {
  EntryStarted = 'EntryStarted',
  WithinCutoff = 'WithinCutoff',
}

export type UpdateVisibilityInput = {
  isReservable: boolean;
  entryStart: Date | null;
  now: Date;
  canUpdateAnytime: boolean;
  cutoffUnit: UpdateCutoffUnitEnum;
  cutoffValue: number;
  timeZone?: string;
};

export type UpdateActionVisibility =
  | { visible: true }
  | { visible: false; reason: UpdateActionBlockedReason };
